import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ForgotPassword } from "../Redux/action/AuthAction";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import ebenchLogo from "../images/ebench_logo.png";

const Forgotpass = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    email: "",
    userType: "",
  });
  const [loader, setLoader] = useState(false);
  // console.log(state)
  const [mess, setMess] = useState("");
  const dispatch = useDispatch();
  const { email, userType } = state;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!userType) {
      setMess("Please Select UserType");
    } else {
      setMess("");
      setLoader(true);
      dispatch(ForgotPassword(state))
        ?.then((res) => {
          if (res?.data) {
              setLoader(false);
            navigate("/verify-reset-otp", { state: { email: res?.data?.email, userType: res?.data?.userType } });          
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log("erer", err);
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <header
        className="d-flex justify-content-between align-items-center px-5 py-3 shadow-sm"
        style={{ backgroundColor: "#fff" }}
      >
        {/* Logo */}
        <div className="landing_logo">
          <Link to="/">
            <img
              src={ebenchLogo}
              alt="Ebench Logo"
              className="responsive-logo-of-without-login"
            />
          </Link>
        </div>

        {/* Menu Items */}
        <div className="landing_menu_items d-flex align-items-center gap-3">
          <Link to="/login">
            <button
              className="btn btn-outline-primary-custom"
              style={{ padding: "6px 20px", fontWeight: 600 }}
            >
              Login
            </button>
          </Link>
        </div>
      </header>

      {/* <div className='Login-logo'><Loginlogo /></div> */}
      <div
        style={{
          minWidth: "100%",
          height: "90vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 16px", // add padding for mobile
        }}
      >
        <div
          style={{
            borderRadius: "10px",
            width: "100%",
            maxWidth: "400px", // limit width on larger screens
            boxShadow: "2px 2px 19px rgba(0, 0, 0, 0.2)",
            padding: "40px 30px",
            backgroundColor: "#fff",
          }}
        >
          <h1 className="text-center">Forgot Password</h1>

          <form onSubmit={handleSubmit}>
            <div className="py-2">
              <select
                required
                className="form-control py-3"
                name="userType"
                id="userType"
                value={userType}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Please fill User Type
                </option>
                <option value="CANDIDATE">Candidate</option>
                <option value="VENDOR">Vendor</option>
              </select>
              <p style={{ color: "red" }}>{mess}</p>
            </div>

            <div className="form-group">
              <input
                type="email"
                className="form-control py-3"
                id="exampleInputEmail1"
                placeholder="Email ID"
                name="email"
                required
                value={email}
                maxLength={254}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex mt-2 justify-content-center align-items-center form-group reg">
              <Button
                type="submit"
                style={{ backgroundColor: "#286a94", color: "white" }}
                className="form-control py-3"
                variant="contained"
                disabled={loader}
              >
                {loader ? "Loading..." : "Continue"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Forgotpass;
